import React, { useState } from "react";
import styles from "./Feedback.module.css";
import validator from "validator";

const Feedback = () => {
  const [formData, setFormData] = useState({
    phone: "",
    email: "",
    name: "",
  });

  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
      e.preventDefault();
      
      const { phone, email, name } = formData;
      setError("");
      setSuccess("");
      
      if (!phone || !email || !name) {
          setError("Заполните все поля");
          return;
      }
      const strictLatinEmailRegex = /^[a-zA-Z0-9@._%+-]+$/;
      if (!strictLatinEmailRegex.test(email)) {
          setError("Email должен содержать только латинские буквы, цифры и символы @ . _ % + -");
          setSuccess("");
          return;
      }
      if (!validator.isEmail(email)) {
          setError("Введите корректный email адрес");
          return;
      }
      
      const phoneRegex = /^\+\d{1,3}\(\d{3}\)\d{3}-\d{2}-\d{2}$/;
      if (!phoneRegex.test(phone)) {
        setError("Телефон должен быть в формате: +7(000)000-00-00");
        setSuccess("");
        return;
      }
      
      if (!validator.isAlpha(name.replace(/[\s\-]/g, ''), 'ru-RU')) {
        setError("Имя может содержать только русские буквы, пробелы и дефисы");
        return;
      }
      if (name.length < 2) {
          setError("Имя должно содержать минимум 2 символа");
          return;
      }
      if (name.length > 50) {
          setError("Имя слишком длинное");
          return;
      }
      
      try {
        
        const response = await fetch("/api/call-back/", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(formData),
        });
        
        if (response.ok) {
          setSuccess("Форма успешно отправлена!");
          setFormData({ phone: "", email: "", name: "" });
        } else {
          const errorData = await response.json();
          
          if (errorData.errors) {
            const errorMessages = Object.values(errorData.errors).join(", ");
            setError(`Произошла ошибка: ${errorMessages}`);
          } else if (errorData.error) {
            setError(`Произошла ошибка: ${errorData.error}`);
          } else {
            setError("Произошла ошибка при отправке формы");
          }
        }
      } catch (err) {
        setError("Ошибка сети. Попробуйте позже.");
      }
  };

  return (
    <div className={styles.feedback}>
      <h2 className={styles.title}>
        Остались вопросы? Закажите бесплатную консультацию
      </h2>
      <form className={styles.form} onSubmit={handleSubmit}>
        <input
          type="text"
          name="phone"
          placeholder="Телефон: +7(000)000-00-00"
          value={formData.phone}
          onChange={handleChange}
          className={styles.input}
        />
        <input
          name="email"
          placeholder="Электронная почта"
          value={formData.email}
          onChange={handleChange}
          className={styles.input}
        />
        <input
          type="text"
          name="name"
          placeholder="Имя"
          value={formData.name}
          onChange={handleChange}
          className={styles.input}
        />
        <button type="submit" className={styles.button}>
          Получить консультацию
        </button>
      </form>
      {error && <p className={styles.error}>{error}</p>}
      {success && <p className={styles.success}>{success}</p>}
    </div>
  );
};

export default Feedback;